var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOrder(_ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-23.14%",
    y1: "49.998%",
    x2: "123.142%",
    y2: "49.998%",
    id: "order_svg__svg-672024881a"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00756A",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#04FCF0",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-20.896%",
    y1: "50%",
    x2: "65.659%",
    y2: "-7.527%",
    id: "order_svg__svg-672024881b"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F68616",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EE2A1E",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15 .214C6.827.214.214 6.827.214 15c0 8.173 6.613 14.786 14.786 14.786 8.173 0 14.786-6.613 14.786-14.786C29.786 6.827 23.173.214 15 .214zm7.316 15.644h-6.673v6.673c0 .46-.367.827-.826.827a.823.823 0 01-.826-.827l-.002-6.673H7.347a.823.823 0 01-.826-.827c0-.459.367-.826.826-.826h6.674V7.53c0-.459.367-.826.826-.826.46 0 .826.367.826.826v6.674h6.674c.46 0 .826.367.826.826a.87.87 0 01-.857.827z",
    fill: "url(#order_svg__svg-672024881a)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 .214C6.827.214.214 6.827.214 15c0 8.173 6.613 14.786 14.786 14.786 8.173 0 14.786-6.613 14.786-14.786C29.786 6.827 23.173.214 15 .214zm7.316 15.644h-6.673v6.673c0 .46-.367.827-.826.827a.823.823 0 01-.826-.827l-.002-6.673H7.347a.823.823 0 01-.826-.827c0-.459.367-.826.826-.826h6.674V7.53c0-.459.367-.826.826-.826.46 0 .826.367.826.826v6.674h6.674c.46 0 .826.367.826.826a.87.87 0 01-.857.827z",
    fill: "url(#order_svg__svg-672024881b)",
    opacity: 0
  }))));
}

export default SvgOrder;